import { ReactElement } from "react";
import styles from './ProgressBar.module.css';
import { ASSET_PREFIX } from "utils/constants";

interface Props {
  variant: string;
  /** The number of the step that we are currently on. This starts from 1, rather than zero */
  progressBars: number;
  /** The total number of bars, however, the variant designs call for a fixed number of named steps */
  numBars: number;
  children: ReactElement;
}

const steps = [
  { name: 'Numbers', iconFilename: 'enter-1.svg' },
  { name: 'Days', iconFilename: 'enter-2.svg' },
  { name: 'Boost', iconFilename: 'enter-3.svg' },
  { name: 'Sign up', altName: 'Sign in', iconFilename: 'enter-4.svg' },
  { name: 'Payment', iconFilename: 'enter-5.svg' },
];


const variants = {
  numbers: 'VARIANT1',
  icons: 'VARIANT2',
  ticks: 'VARIANT3',
};

const EnterProgressBar = (props: Props) => {
  if (props.variant) {
    const isNumbers = props.variant === variants.numbers;
    const isIcons = props.variant === variants.icons;
    const isTicks = props.variant === variants.ticks;

    return (
      <div className={styles.stepContainerOuter}>
        <div className={`${styles.stepContainer} ${isNumbers ? styles.numbers : ''} ${isIcons ? styles.icons : ''} ${isTicks ? styles.ticks : ''} ${styles['stepIndex__' + props.progressBars]}`}>
          {
            steps.map((x, index) => {
              return (
                <div className={`${styles.step} ${(index >= props.progressBars) ? styles.upcoming : ''}`}>
                  <div className={styles.circle}>
                    {
                      isNumbers
                        ? (index + 1)
                        : isIcons
                          ? <img src={ASSET_PREFIX + '/images/enter/2025/' + x.iconFilename} />
                          : <img src={ASSET_PREFIX + '/images/enter/2025/enter-tick.svg'} />
                    }
                  </div>
                  {props.variant != variants.icons &&
                    <div className={styles.label}>
                      {x.name}
                    </div>
                  }
                </div>
              )
            })
          }
        </div>
      </div>
    );
  }

  // We don't have a variant, just use the children we are given (i.e the existing component)
  return props.children;
}


// Replace the default export with this line to see all variants at once
//    export default (props: Props) => <div style={{ width: "100%" }}>{Object.values(variants).map(x => <EnterProgressBar {...props} variant={x} />)}</div>;
export default EnterProgressBar;
